import type { PartySelectOption } from 'app/components/core/users/types';
import { getLocalPartiesErrorMessage } from 'app/utils/helpers/local-parties-error';
import { localPartyIdsToDtos, partySelectAdapter } from 'app/utils/helpers/party-select-adapter';
import { useLocalParties } from 'data';

export function useLocalPartiesForSelect(participantName: string, partyFieldName: 'identifier' | 'party') {
  const { data, isFetching, error, refetch } = useLocalParties(participantName);

  const partyIds = data?.parties ?? [];

  const localParties: PartySelectOption[] | undefined =
    partyIds.length > 0
      ? (partySelectAdapter(localPartyIdsToDtos(partyIds), partyFieldName) as PartySelectOption[])
      : undefined;

  return {
    localParties,
    isFetchingLocalParties: isFetching,
    hasNoLocalParties: !isFetching && data !== undefined && partyIds.length === 0,
    fetchErrorMessage: !isFetching && error ? getLocalPartiesErrorMessage(error, partyIds.length > 0) : undefined,
    onFetchLocalParties: () => {
      refetch();
    },
  };
}
